export async function parseJsonResponse(response) {
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message =
      (typeof body.error === 'string' && body.error) ||
      (typeof body.message === 'string' && body.message) ||
      'Request failed.';
    throw new Error(message);
  }

  return body;
}

/** Unwrap a single Laravel JsonResource item if nested under `data`. */
export function normalizeApiRecord(record) {
  if (!record || typeof record !== 'object') {
    return record;
  }
  if (record.data && typeof record.data === 'object' && !Array.isArray(record.data)) {
    return record.data;
  }
  return record;
}

/** Normalize Laravel paginated list payloads (`data.items` or wrapped resource collections). */
export function extractPaginatedList(result) {
  const rawItems = result?.data?.items;
  const list = Array.isArray(rawItems)
    ? rawItems
    : Array.isArray(rawItems?.data)
      ? rawItems.data
      : [];

  const items = list.map(normalizeApiRecord);
  const pagination = result?.data?.pagination || { lastPage: 1, total: 0 };

  return { items, pagination };
}

export function postJson(url, payload) {
  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  }).then(parseJsonResponse);
}
